"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

exports.__esModule = true;
exports["default"] = void 0;

var _ascent = _interopRequireDefault(require("./ascent"));

var _descent = _interopRequireDefault(require("./descent"));

var _lineGap = _interopRequireDefault(require("./lineGap"));
/**
 * Get run height
 *
 * @param  {Object}  run
 * @return {number} height
 */


var height = function height(run) {
  var _run$attributes;

  var lineHeight = (_run$attributes = run.attributes) === null || _run$attributes === void 0 ? void 0 : _run$attributes.lineHeight;
  return lineHeight || (0, _lineGap["default"])(run) + (0, _ascent["default"])(run) - (0, _descent["default"])(run);
};

var _default = height;
exports["default"] = _default;